import type React from "react";

export function FolderIcon(): React.ReactElement {
  return (
    <svg
      aria-hidden="true"
      className={[
        "icon-xs",
        "shrink-0",
        "text-token-description-foreground",
      ].join(" ")}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 6.25C2.5 4.86929 3.61929 3.75 5 3.75H7.442C8.10504 3.75 8.74093 4.01339 9.20971 4.48223L10.25 5.5225C10.4844 5.75693 10.8024 5.88861 11.1339 5.88861H15C16.3807 5.88861 17.5 7.0079 17.5 8.38861V13.75C17.5 15.1307 16.3807 16.25 15 16.25H5C3.61929 16.25 2.5 15.1307 2.5 13.75V6.25ZM5 5C4.30964 5 3.75 5.55964 3.75 6.25V7.13861H16.25C16.25 7.13861 16.25 7.13861 16.25 7.13861C15.921 6.82494 15.4802 6.63861 15 6.63861H11.1339C10.4708 6.63861 9.83496 6.37522 9.36618 5.90638L8.32589 4.86612C8.09146 4.63169 7.77352 4.5 7.442 4.5H5ZM3.75 8.38861V13.75C3.75 14.4404 4.30964 15 5 15H15C15.6904 15 16.25 14.4404 16.25 13.75V8.38861H3.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
